module.exports = __webpack_public_path__ + "img/tw_logo.f29749a2.svg";